export function registerNativeBridge(store, { onSessionReady } = {}) {
  const handlers = {
    getAppConfig(sessionKey, sessionToken, sessionTuitionPayment) {
      const isTuitionPayment = sessionTuitionPayment === true || sessionTuitionPayment === 'true'

      store.dispatch('setSession', {
        sessionKey,
        sessionToken,
        ...(isTuitionPayment ? { sessionTuitionPayment } : {}),
      })

      if (sessionKey != null && typeof onSessionReady === 'function') {
        onSessionReady()
      }
    },

    getPaymentFeatureConfig(isShowFeature) {
      store.dispatch('setSupportFeatures', isShowFeature)
    },

    setDefaultCarrier(carrier) {
      store.dispatch('setDefaultCarrier', carrier)
    },

    handleActionError() {},
  }

  Object.keys(handlers).forEach((name) => {
    window[name] = handlers[name]
  })


  const queued = window.__bridgeQ || []
  window.__bridgeQ = []
  queued.forEach(({ name, args }) => {
    if (typeof handlers[name] !== 'function') {
      return
    }

    try {
      handlers[name].apply(null, args)
    } catch (e) {
      console.error(`[nativeBridge] replay failed: ${name}`, e)
    }
  })

  store.dispatch('getDeviceInformation')
}
